export const LastVar = () => {
  return window.location.href.substring(
    window.location.href.lastIndexOf("/") + 1
  );
};
